import React, { useState, useEffect, useRef } from "react";
import useHttp from '../utils/http';
import { Box, Container, FormControl, FormLabel, Input, Stack, Button, Text } from '@chakra-ui/react';

const Print = () => {
    const { post } = useHttp();
    const [sap, setSap] = useState('');
    const [serie, setSerie] = useState('');
    const [epc, setEpc] = useState('');
    const sapInputRef = useRef(null);
    const serieInputRef = useRef(null);

    useEffect(() => {
        sapInputRef.current?.focus();
    }, []);
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            serieInputRef.current?.focus();
        }
    };
    const handleEnviar = async () => {
        try {
            const username = process.env.REACT_APP_USER;
            const password = process.env.REACT_APP_PASSWORD;
            const token = btoa(`${username}:${password}`);

            const response = await post('/api/print',
                { sap, serie },
                {
                    headers: {
                        'Authorization': `Basic ${token}`
                    }
                }
            );

            console.log(response.data);
            setEpc(response.data.epc);
            // Handle response here
        } catch (error) {
            console.error('There was an error!', error);
            // Handle error here
        }
    }


    const handleClear = () => {
        setSap('');
        setSerie('');
        setEpc('');
    };

    return (
        <Box as="section" bg="bg.surface" pt="12" pb={{ base: '4', md: '8' }}>
            <Container maxW="lg">
                <Stack spacing="10">
                    <FormControl>
                        <Input
                            id="sap"
                            size="lg"
                            placeholder="SAP"
                            value={sap}
                            onChange={(e) => setSap(e.target.value)}
                            onKeyPress={handleKeyPress} // Attach handleKeyPress here
                            inputMode="none"
                            ref={sapInputRef}
                        />
                        <FormLabel htmlFor="sap" variant="floating" size="lg">
                            SAP
                        </FormLabel>
                    </FormControl>

                    <FormControl>
                        <Input
                            id="serie"
                            size="lg"
                            placeholder="Serie"
                            value={serie}
                            inputMode="none"
                            onChange={(e) => setSerie(e.target.value)}
                            ref={serieInputRef} // Set the ref here
                        />
                        <FormLabel htmlFor="serie" variant="floating" size="lg">
                            Serie
                        </FormLabel>
                    </FormControl>


                    {epc ? <Text>{epc}</Text> : <Button colorScheme="blue" onClick={handleEnviar}>Enviar</Button>}
                    <Button colorScheme="gray" onClick={handleClear}>Clear</Button>

                </Stack>
            </Container>
        </Box>
    );
}

export default Print;
